import React, { useState } from 'react';
import { loginUser } from '../api/userApi';
import { useUser } from '../context/UserContext';

import '../StylesCSS/styles.css';
import { useNavigate } from 'react-router-dom';

import imageSchool from '../Images/Photo1.PNG';

const Log = ({ setAuth }) => {

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { setUserId } = useUser();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await loginUser({ email, password });

      console.log('API response:', response);

      if (response.data) {
        setAuth(true);
        setUserId(response.data.id);

        console.log("userId set to:", response.data.id);
      } else {
        alert("Email ou mot de passe incorrect.");
      }
    } catch (error) {
      console.error(error);
      alert("Erreur lors de la connexion.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-brand-panel">
          <div className="brand-badge">AL-BAWSALA</div>

          <img
            className="brand-image"
            src={imageSchool}
            alt="Illustration du portail"
          />

          <h1>
            Bienvenue dans votre
            <span>espace privé.</span>
          </h1>

          <p className="arabic-text">
            البوصلة هي منصة رقمية موجهة لمستشاري التوجيه التربوي. هي بمثابة لوحة قيادة
            للمساعدة على تنظيم، تبسيط وأرشفة المهام المنجزة على شكل تقارير يومية
            (بطاقات تقنية) شهرية أو دورية.
          </p>

          <p className="arabic-text muted">
            سنعمل على تطوير البوصلة ليصبح بمقدورها مساعدتك على تدبير مجالس الأقسام في نهاية
            السنة الدراسية وتقديم جميع الإحصائيات والمذكرات المطلوبة.
          </p>
        </div>

        <div className="login-form-panel">
          <div className="auth-card">
            <div className="auth-card-header">
              <span className="header-kicker">Accès sécurisé</span>
              <h2>Se connecter</h2>
            </div>

            <div className="auth-card-body">
              <h3>Bienvenue</h3>
              <p>
                Connectez-vous pour accéder à toutes les fonctionnalités.
              </p>

              <form onSubmit={handleLogin} className="login-form">
                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="floatingInput"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@example.com"
                    required
                  />
                  <label htmlFor="floatingInput">Email</label>
                </div>

                <div className="form-floating auth-field">
                  <input
                    className="form-control"
                    id="floatingPassword"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mot de passe"
                    required
                  />
                  <label htmlFor="floatingPassword">Mot de passe</label>
                </div>

                <div className="auth-actions">
                  <button
                    type="button"
                    onClick={() => navigate('/forgot-password')}
                    className="btn btn-link forgot-link"
                  >
                    Mot de passe oublié ?
                  </button>
                </div>

                <button className="btn btn-primary login-button" type="submit">
                  Se Connecter
                </button>
              </form>
            </div>

            <div className="auth-card-footer">
              <span>Pas encore membre ?</span>
              <button
                type="button"
                onClick={() => navigate('/register')}
                className="btn btn-link signup-link"
              >
                Inscrivez-vous
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Log;